// extracted by mini-css-extract-plugin
export default {"fitMatch":"rx8EPHadBAGNi2SeTuvX","figureWrapper":"FovjigI99g6DDh7ssrtK","circles":"vT_CfwKOuHgvdc1uqAMI","overlap":"UoMqYHSX1sEWpwEm4COQ"};